import { __awaiter, __generator } from 'tslib';
import React__default from 'react';
import { CartContext } from '../../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import { getReflexOptionsWithGroupedAddOns } from '../OrderCard.utils.esm.js';
import '../../../constants/analytics.esm.js';
import '../../../modals/content/index.esm.js';
import '../../../modals/content/default_validation_error.esm.js';
import '../../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../../constants/api.esm.js';
import Select from '../../Select/index.esm.js';
import { NO_REFLEX_TESTS_ERROR_MESSAGE } from '../ReflexContainer/ReflexContainer.esm.js';
import ReflexTestsStaticList from '../ReflexContainer/ReflexTestsStaticList/ReflexTestsStaticList.esm.js';
import ReflexTest from '../ReflexTest/ReflexTest.esm.js';
import RereqTooltip from '../RereqTooltip/RereqTooltip.esm.js';
import reflexStyles from '../ReflexContainer/ReflexContainer.module.esm.js';
import reflexTestSelectionStyles from '../ReflexContainer/ReflexTestSelection/ReflexTestSelection.module.esm.js';
import styles from './RereqContainer.module.esm.js';

var RereqContainer = function () {
    var _a, _b, _c;
    var _d = React__default.useContext(CartContext), addRereqTests = _d.addRereqTests, clearRereqCustomizedSelection = _d.clearRereqCustomizedSelection, removeRereqTests = _d.removeRereqTests, searchRereqTests = _d.searchRereqTests, meta = _d.meta, rereqValidationError = _d.rereqValidationError;
    var _e = React__default.useContext(CartSettingsContext), isCompact = _e.isCompact, isEditable = _e.isEditable;
    var loadRereqOptions = React__default.useCallback(function (query) { return __awaiter(void 0, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, searchRereqTests(query)];
                case 1:
                    options = (_a.sent()) || [];
                    return [2 /*return*/, getReflexOptionsWithGroupedAddOns(options)];
            }
        });
    }); }, [searchRereqTests]);
    var handleTestSelection = React__default.useCallback(function (option) {
        // in case the option was cleared, the onChange is still called
        if (!option)
            return;
        var tests = option.isCustomPanel ? option.geneCodes : [option.value];
        addRereqTests(tests);
    }, [addRereqTests]);
    var handleTestRemoval = React__default.useCallback(function (_a) {
        var isCustom = _a.isCustom, code = _a.code;
        isCustom ? clearRereqCustomizedSelection() : removeRereqTests([code]);
    }, [clearRereqCustomizedSelection, removeRereqTests]);
    var rereqTestSelectionValidationErrorMessage = React__default.useMemo(function () {
        if (!rereqValidationError)
            return null;
        return (React__default.createElement("span", { className: reflexStyles["validationError".concat(isCompact ? 'Compact' : '')], "data-testid": "rereq-error" }, NO_REFLEX_TESTS_ERROR_MESSAGE));
    }, [isCompact, rereqValidationError]);
    return (React__default.createElement("div", { className: isCompact ? reflexStyles.rootCompact : reflexStyles.root, "data-testid": "rereq-container" },
        isEditable ? (React__default.createElement("div", { className: reflexStyles.inner },
            React__default.createElement("div", { className: reflexTestSelectionStyles.root, "data-testid": "rereq-test-selection" },
                React__default.createElement("div", { className: styles.labelWrapper },
                    React__default.createElement("div", { className: styles.label }, "Select reflex test"),
                    React__default.createElement(RereqTooltip, { className: styles.tooltip })),
                React__default.createElement("div", { className: reflexTestSelectionStyles.dropdownWrapper },
                    React__default.createElement(Select, { loadOptions: loadRereqOptions, onChange: handleTestSelection, placeholder: "Add a test" })),
                React__default.createElement("div", { className: styles.rereqTestsWrapper }, (_b = (_a = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _a === void 0 ? void 0 : _a.richRereqTests) === null || _b === void 0 ? void 0 : _b.map(function (test) {
                    var _a;
                    return (React__default.createElement("div", { className: styles.rereqTest, "data-testid": "rereq-test-item", key: test.code },
                        React__default.createElement(ReflexTest, { removeReflexTest: handleTestRemoval, test: test }), (_a = test === null || test === void 0 ? void 0 : test.addOns) === null || _a === void 0 ? void 0 :
                        _a.map(function (addOn) { return (React__default.createElement(ReflexTest, { isAddon: true, key: addOn.code, removeReflexTest: handleTestRemoval, test: addOn })); })));
                }))))) : (React__default.createElement(ReflexTestsStaticList, { tests: (_c = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _c === void 0 ? void 0 : _c.richRereqTests })),
        rereqTestSelectionValidationErrorMessage));
};

export { RereqContainer as default };
//# sourceMappingURL=RereqContainer.esm.js.map
